import React, { useState, useRef } from 'react';


interface InlineSelectProps {
  id?: string;
  value: string | number;
  onChange: (id: number) => void;
  opzioni: { id: number; label: string }[];
  placeholder?: string;
  onCrea: (nome: string) => Promise<{ id: number; label: string }>;
  disabled?: boolean;
  className?: string;
}

const CREA_VALUE = '__CREA__';

export default function InlineSelect({
  id,
  value,
  onChange,
  opzioni,
  placeholder = 'Seleziona...',
  onCrea,
  disabled = false,
  className = '',
}: InlineSelectProps) {
  const [modalitaCrea, setModalitaCrea] = useState(false);
  const [nuovoNome, setNuovoNome] = useState('');
  const [creating, setCreating] = useState(false);
  const [errore, setErrore] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value === CREA_VALUE) {
      setModalitaCrea(true);
      setNuovoNome('');
      setErrore('');
      setTimeout(() => inputRef.current?.focus(), 50);
    } else if (e.target.value !== '') {
      onChange(Number(e.target.value));
    }
  };

  const handleConferma = async () => {
    if (!nuovoNome.trim()) {
      setErrore('Il nome non può essere vuoto');
      return;
    }
    setCreating(true);
    setErrore('');
    try {
      const nuovoItem = await onCrea(nuovoNome.trim());
      onChange(nuovoItem.id);
      setModalitaCrea(false);
      setNuovoNome('');
    } catch (err: any) {
      setErrore(err.message || 'Errore nella creazione');
    } finally {
      setCreating(false);
    }
  };

  const handleAnnulla = () => {
    setModalitaCrea(false);
    setNuovoNome('');
    setErrore('');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') { e.preventDefault(); handleConferma(); }
    if (e.key === 'Escape') handleAnnulla();
  };

  if (modalitaCrea) {
    return (
      <div className={`inline-select-crea-wrapper ${className}`}>
        <input
          ref={inputRef}
          type="text"
          className="bop-input inline-select-input"
          value={nuovoNome}
          onChange={(e) => setNuovoNome(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Digita il nome..."
          disabled={creating}
        />
        <button
          type="button"
          className="inline-select-btn-conferma"
          onClick={handleConferma}
          disabled={creating}
          title="Conferma"
        >
          {creating ? '…' : '✓'}
        </button>
        <button
          type="button"
          className="inline-select-btn-annulla"
          onClick={handleAnnulla}
          disabled={creating}
          title="Annulla"
        >
          ✕
        </button>
        {errore && <span className="inline-select-errore">{errore}</span>}
      </div>
    );
  }

  return (
    <select
      id={id}
      className={`bop-select ${className}`}
      value={value === null || value === undefined || value === '' ? '' : value}
      onChange={handleSelectChange}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {opzioni.map(o => (
        <option key={o.id} value={o.id}>{o.label}</option>
      ))}
      <option value={CREA_VALUE}>+ Crea nuovo...</option>
    </select>
  );
}
